import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { getExtension } from '../../extension-details/state/extension-detail.selectors';
import { AddHardphoneApiService } from '../services/add-hardphone-api.service';
import * as AddHardphoneActions from './add-hardphone.actions';

@Injectable()
export class AddHardphoneEffects {
   addHardphone$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddHardphoneActions.addPhone),
         withLatestFrom(this.store.select(getExtension)),
         switchMap(([action]) => {
            return this.addHardphoneApiService.saveHardphone(action.hardphoneAdd).pipe(
               map((executionResult) => {
                  return AddHardphoneActions.addHardphoneSuccess({
                     phoneType: executionResult.data.phone.phoneType,
                  });
               }),
               catchError((error) => {
                  return of(AddHardphoneActions.addHardphoneFailure(error));
               })
            );
         })
      );
   });

   addHardphoneSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddHardphoneActions.addHardphoneSuccess),
            tap((result) => {
               this.dialogService.closeFormComponent();
               this.snackbar.open(`${result.type} Hardphone Saved`, undefined, {
                  duration: 3000,
               });
            })
         );
      },
      { dispatch: false }
   );

   constructor(
      private actions$: Actions,
      private addHardphoneApiService: AddHardphoneApiService,
      private store: Store,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService
   ) {}
}
